export default {
  empty_payment_method: {
    add: "Zahlungsmethode hinzufügen",
  },
};
